<template>
    <li class="dropdown dropdown-notification nav-item">
        <a class="nav-link nav-link-label" href="#" data-toggle="dropdown">
            <i class="ficon feather icon-bell"></i>

            <span
                v-if="count > 0"
                class="badge badge-pill badge-danger badge-up"
            >
                {{ count }}
            </span>
        </a>

        <ul class="dropdown-menu dropdown-menu-media dropdown-menu-right">
            <li class="dropdown-menu-header">
                <h6 class="dropdown-header m-0">
                    <span class="grey darken-2">Notifications</span>
                </h6>
            </li>

            <li class="scrollable-container media-list">
                <template v-if="notifications.length">
                    <a
                        v-for="notification in notifications"
                        :key="notification.id"
                        :href="`/admin/orders/${notification.data.order_id}`"
                        class="media"
                    >
                        <div class="media-left align-self-center">
                            <i class="icon p-1 icon-basket-loaded icon-bg-circle bg-info"></i>
                        </div>

                        <div class="media-body">
                            <h6 class="media-heading">
                                {{ notification.title ?? 'New Notification' }}
                            </h6>

                            <p class="notification-text font-small-3 text-muted">
                                {{ notification.message }}
                            </p>

                            <small class="media-meta text-muted">
                                {{ notification.created_at }}
                            </small>
                        </div>
                    </a>
                </template>

                <p v-else class="text-center p-2 text-muted">
                    No notifications
                </p>
            </li>

            <li
                v-if="unreadCount > 0"
                class="dropdown-menu-footer"
            >
                <button
                    class="dropdown-item align-content-center"
                    @click="markAllAsRead"
                >
                    Mark all as read
                </button>
            </li>
        </ul>
    </li>
</template>

<script>
import Layout from '@/Shared/Layout'
import Echo from 'laravel-echo'

export default {
    metaInfo: { title: 'Notification' },
    name: 'Notification',
    layout: Layout,
    props: ['notifications', 'count', 'user',],

    data: () => ({
        echo: null,
        realTimeData: {
            newRides: 0,
            completedRides: 0
        }
    }),

    mounted() {
        alert('Test event received: ' + data.message);

        // this.initializeEcho()
        // this.listenToEvents()
        // this.loaded = true
    },

    methods: {
        // initializeEcho() {
        //     this.echo = new Echo({
        //         broadcaster: 'reverb',
        //         key: process.env.MIX_REVERB_APP_KEY,
        //         wsHost: window.location.hostname,
        //         wsPort: process.env.MIX_REVERB_PORT || 80,
        //         wssPort: process.env.MIX_REVERB_SSL_PORT || 443,
        //         forceTLS: false, // set to true in production
        //         enabledTransports: ['ws', 'wss'],
        //     })
        // },

        listenToEvents() {
            this.echo.channel('test-channel')
                .listen('.test.event', (data) => {
                    console.log('Test event received:', data.message);
                    // You could show a notification or update UI
                    alert('Test event received: ' + data.message);
                });

            // Example: Listen for new ride events
            // this.echo.channel('dashboard-updates')
            //     .listen('.ride.created', (data) => {
            //         this.realTimeData.newRides++
            //         console.log('New ride created:', data)
            //         // You could also update your props or trigger UI updates here
            //     })
            //     .listen('.ride.completed', (data) => {
            //         this.realTimeData.completedRides++
            //         console.log('Ride completed:', data)
            //     })

            // For private channels (if needed)
            // this.echo.private(`driver.${this.user.id}`)
            //     .listen('.driver.assigned', (data) => {...})
        },
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    },

    beforeDestroy() {
        // Clean up Echo connection when component is destroyed
        if (this.echo) {
            this.echo.disconnect()
        }
    }
}
</script>
